import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppConstants } from '../AppConstants';
import { AuthService } from '../service/auth.service';
import { UIRoutes } from '../UIRoutes';

@Component({
  selector: 'app-facility-details',
  templateUrl: './facility-details.component.html',
  styleUrls: ['./facility-details.component.css']
})
export class FacilityDetailsComponent implements OnInit {
  facilityTypes;
  cities = [
    "Adoni","Agartala","Agra","Ahmednagar","Aizawl","Ajmer","Akola",
    "Alappuzha","Aligarh","Allahabad","Alwar","Amaravati","Ambala",
    "Ambattur","Ambernath","Amravati","Amritsar","Amroha","Anand",
    "Anantapur","Arrah","Asansol","Aurangabad","Avadi","Bagaha",
    "Baharampur","Bahraich","Bally","Bangalore","Baranagar","Barasat",
    "Bardhaman","Bareily","Bathinda","Begusarai","Belgaum","Bellary",
    "Berhampur","Bettiah","Bhagalpur","Bhalswa Jahangir Pur","Bharatpur",
    "Bhatpara","Bhavnagar","Bhilai","Bhilwara","Bhimavaram","Bhind",
    "Bhiwandi","Bhiwani","Bhopal","Bhubaneswar","Bhuj","Bhusawal",
    "Bidar","Bidhan Nagar","Bihar Sharif","Bijapur","Bilaspur","Bikaner",
    "Bokaro","Bulandshahr","Burhanpur","Buxar","Chandigarh","Chandrapur",
    "Chennai","Chapra","Chittoor","Coimbatore","Cuttack","Danapur",
    "Darbhanga","Davanagere","Dehradun","Dehri","Delhi","Deoghar",
    "Dewas","Dhanbad","Dharmavaram","Dhule","Dindigul","Durg","Durgapur",
    "Eluru","Erode","Etawah","Faridabad","Farrukhabad","Fatehpur",
    "Firozabad","Gandhidham","Gandhinagar","Gaya","Ghaziabad",
    "Gopalpur","Gorakhpur","Gudivada","Gulbarga","Guna","Guntakal",
    "Guntur","Gurgaon","Guwahati","Gwalior","Hajipur","Haldia",
    "Hapur","Haridwar","Hindupur","Hospet","Howrah","Hubballi-Dharwad",
    "Hugli and Chinsurah","Hyderabad","Ichalkaranji","Imphal","Indore",
    "Jabalpur","Jaipur","Jalandhar","Jalgaon","Jalna","Jamalpur",
    "Jammu","Jamnagar","Jamshedpur","Jaunpur","Jehanabad","Jhansi",
    "Jodhpur","Junagadh","Kadapa","Kakinada","Kalyan-Dombivali",
    "Kamarhati","Kanpur","Karaikudi","Karawal Nagar","Karimnagar",
    "Karnal","Katihar","Kavali","Khammam","Khandwa","Kharagpur",
    "Khora","Kirari Suleman Nagar","Kishanganj","Kochi","Kolhapur",
    "Kolkata","Kollam","Korba","Kota","Kottayam","Kozhikode","Kulti",
    "Kurnool","Latur","Loni","Lucknow","Ludhiana","Machilipatnam",
    "Madanapalle","Madhyamgram","Madurai","Mahesana","Maheshtala",
    "Malda","Malegaon","Mangalore","Mango","Mathura","Mau","Meerut",
    "Mumbai","Mira-Bhayandar","Miryalaguda","Mirzapur","Moradabad",
    "Morena","Morvi","Motihari","Munger","Murwara","Muzaffarnagar",
    "Muzaffarpur","Mysore","Nadiad","Nagarcoil","Naihati","Nanded",
    "Nandyal","Nangloi Jat","Narasaraopet","Nashik","Navi Mumbai",
    "Navi Mumbai Panvel Raigad","Nellore","New Delhi","Nizamabad",
    "Noida","North Dumdum","Ongole","Orai","Ozhukarai","Pali",
    "Pallavaram","Panchkula","Panihati","Panipat","Panvel","Parbhani",
    "Patiala","Patna","Pimpri-Chinchwad","Proddatur","Puducherry",
    "Pune","Purnia","Rae Bareli","Raichur","Raiganj","Raipur",
    "Rajahmundry","Rajkot","Rajpur Sonarpur","Ramagundam","Rampur",
    "Ranchi","Ratlam","Raurkela Industrial Township","Rewa","Rohtak",
    "Rourkela","Sagar","Saharanpur","Saharsa","Salem","Sambalpur",
    "Sambhal","Sangli-Miraj & Kupwad","Sasaram","Satara","Satna",
    "Secunderabad","Serampore","Shahjahanpur","Shimla","Shivamogga",
    "Shivpuri","Sikar","Siliguri","Singrauli","Sirsa","Siwan",
    "Solapur","Sonipat","South Dumdum","Srinagar","Sri Ganganagar",
    "Srikakulam","Sultan Pur Majra","Surat","Surendranagar Dudhrej",
    "Suryapet","Tadepalligudem","Tadipatri","Tenali","Thane",
    "Thanjavur","Thiruvananthapuram","Thoothukudi","Thrissur",
    "Tiruchirappalli","Tirunelveli","Tirupati","Tiruppur",
    "Tiruvottiyur","Tumkur","Udaipur","Ujjain","Ulhasnagar",
    "Uluberia","Unnao","Vadodara","Varanasi","Vasai-Virar",
    "Vellore","Vijayawada","Vijayanagaram","Visakhapatnam",
    "Warangal","Yamunanagar"
  ];
  public selectedFacilityTypeValue;
  public selectedCityValue;
  facilityDetailsFormGroup: FormGroup;
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.getFacilityDetails().subscribe(
      response => {
        this.facilityTypes = response;
      }
    );

    this.facilityDetailsFormGroup = new FormGroup({
      facilityNameFormControl: new FormControl('', [
        Validators.required
      ]),
      facilityTypeFormControl: new FormControl('', [
        Validators.required
      ]),
      addressLine1FormControl: new FormControl('', [
        Validators.required
      ]),
      addressLine2FormControl: new FormControl('', [
        Validators.required
      ]),
      cityFormControl: new FormControl('', [
        Validators.required
      ]),
      pincodeFormControl: new FormControl('', [
        Validators.required
      ]),
      phoneNumber1FormControl: new FormControl('', [
        Validators.required,
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(10), Validators.maxLength(10)
      ]),
      phoneNumber2FormControl: new FormControl('', [
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(10), Validators.maxLength(10)
      ]),
      phoneNumber3FormControl: new FormControl('', [
        Validators.pattern("^[0-9]*$"),
        Validators.minLength(10), Validators.maxLength(10)
      ]),
      emailFormControl: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[\w._%+\-]+@[\w.\-]+\.[a-zA-Z]{2,}(,\s*[\w._%+\-]+@[\w.\-]+\.[a-zA-Z]{2,})*$/)
      ])
    })
  }

  get facilityDetailsFormControls() {
    return this.facilityDetailsFormGroup.controls;
  }

  selectValueChangeForFacilityType() {
    console.log(this.selectedFacilityTypeValue);
  }

  selectValueChangeForCity() {
    console.log(this.selectedCityValue);
  }

  onNextClicked() {
    const facilityDetails = {
      userName: JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT)).username,
      tenantName: this.facilityDetailsFormGroup.get("facilityNameFormControl").value,
      address: {
        addressLine1: this.facilityDetailsFormGroup.get("addressLine1FormControl").value,
        addressLine2: this.facilityDetailsFormGroup.get("addressLine2FormControl").value,
        city: this.facilityDetailsFormGroup.get("cityFormControl").value,
        pinCode: this.facilityDetailsFormGroup.get("pincodeFormControl").value,
        country: "India"
      },
      tenantType: "Customer",
      tenantCategoryId: Number(this.facilityDetailsFormGroup.get("facilityTypeFormControl").value),
      contactPhoneNumber1: this.facilityDetailsFormGroup.get("phoneNumber1FormControl").value,
      contactPhoneNumber2: this.facilityDetailsFormGroup.get("phoneNumber2FormControl").value,
      contactPhoneNumber3: this.facilityDetailsFormGroup.get("phoneNumber3FormControl").value,
      email: this.facilityDetailsFormGroup.get("emailFormControl").value
    }
    this.authService.createTenantV2(facilityDetails).subscribe(
      (response: any) => {
        console.log(response);
        console.log("facility details created successfully");
        var user = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT));
        user.tenantId = response.id;
        sessionStorage.setItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT, JSON.stringify(user));
        this.router.navigateByUrl(UIRoutes.ROUTING_MODULE_LANDING_PAGE);
      }
    );
  }

}
